import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { ArrowLeft, Users } from 'lucide-react';
import { useState } from 'react';

const FollowList = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isFollowers = location.pathname.includes('followers');
  const [activeTab, setActiveTab] = useState(isFollowers ? '粉丝' : '关注');

  const users = [
    { id: 1, name: '旅行家小王', bio: '热爱摄影与徒步，走遍中国三十省' },
    { id: 2, name: '摄影师李', bio: '记录世界的美好瞬间，分享光影故事' },
    { id: 3, name: '背包客阿杰', bio: '穷游达人，省钱攻略制造机' },
  ];

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="flex items-center gap-3 mb-6">
          <Button variant="ghost" onClick={() => navigate(-1)} className="text-text-secondary hover:text-primary">
            <ArrowLeft className="w-4 h-4 mr-1" /> 返回
          </Button>
          <h1 className="text-xl font-bold text-text-primary">{activeTab}</h1>
        </div>

        <div className="flex gap-6 mb-6 border-b border-[#E8E4DF]">
          {['粉丝', '关注'].map((t) => (
            <button
              key={t}
              onClick={() => setActiveTab(t)}
              className={`pb-2 text-sm font-medium transition-colors ${activeTab === t ? 'text-primary border-b-2 border-primary' : 'text-text-secondary hover:text-primary'}`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="space-y-3">
          {users.length === 0 ? (
            <div className="text-center py-20">
              <Users className="w-16 h-16 text-text-tertiary opacity-40 mx-auto mb-4" />
              <p className="text-text-secondary">还没有{activeTab}</p>
            </div>
          ) : (
            users.map((u) => (
              <Card key={u.id} className="border-0 shadow-card rounded-card bg-white">
                <CardContent className="p-4 flex items-center gap-4">
                  <Avatar className="w-12 h-12">
                    <AvatarFallback className="bg-primary-light text-primary font-medium">{u.name[0]}</AvatarFallback>
                  </Avatar>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-text-primary">{u.name}</p>
                    <p className="text-xs text-text-secondary truncate">{u.bio}</p>
                  </div>
                  <Button size="sm" className="rounded-btn bg-primary hover:bg-primary-hover text-white h-8 text-xs">
                    关注
                  </Button>
                  <button onClick={() => navigate(`/user/${u.id}`)} className="text-xs text-primary hover:underline shrink-0">
                    主页
                  </button>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowList;
